'use client'

import React from 'react'
import Card from '~/components/ui/card'
import { TickSvg } from '~/icons/ic_tick'
import { getTranslation } from '~/lib/i18n-utils'
import { useLocale } from '~/contexts/LocaleContext'

export interface HotelOption {
  label: string
  value: string
}

interface HotelSelectorProps {
  hotels: HotelOption[]
  selectedHotel?: string
  onHotelSelect: (value: string) => void
}

export default function HotelSelector({
  hotels,
  selectedHotel,
  onHotelSelect,
}: HotelSelectorProps) {
  const { locale } = useLocale()
  const t = getTranslation(locale)
  return (
    <Card className="mb-4" padding={0}>
      <div className="w-full">
        <h3 className="mb-2 font-lexend text-base font-medium text-secondary-950">
          {t('booking.selectHotel')}
        </h3>
        <div className="my-3 h-[1px] w-full bg-[#F3F3F3]"></div>
        <div className="space-y-1">
          {hotels.map((hotel, index) => (
            <div
              key={index}
              className={`flex cursor-pointer items-center justify-between px-3 py-2 font-lexend text-[14px] font-light hover:bg-gray-50 ${
                selectedHotel === hotel.value ? 'bg-primary-50 font-medium text-primary-500' : ''
              }`}
              onClick={() => onHotelSelect(hotel.value)}
            >
              <span>{hotel.label}</span>
              {selectedHotel === hotel.value && <TickSvg />}
            </div>
          ))}
        </div>
      </div>
    </Card>
  )
}
